import * as React from "react";
import {Link} from "react-router-dom";
import {ProductRatingType} from "../../../model/product/ProductRatingType";
import {viewOddDetailsButtonStyle} from "../../common/buttonStyles";
import {RaisedButton} from "../../common/RaisedButton";
import {getRatingTextClass} from "../../../utils/commonStyles";
import {NOT_RATED, NR_RATING, OddRatingDescriptions} from "../../../utils/ratingConstants";
import {FormattedMessage} from "react-intl";
import {ITooltipProps, Tooltip} from "../../common/Tooltip";
import {IInformSummary} from "../../../model/inform/InformSummary";
import {Disclosures} from "./Disclosures";
import {getTranslation} from "../../../utils/translationUtil";

export interface IOverallRatingProps {
    currentRating: string | null;
    currentRatingDate: string | null;
    previousRating: string | null;
    previousRatingDate?: string | null;
    isSmallText?: boolean;
    ratingType: ProductRatingType;
    isOperationalDueDiligenceRating: boolean;
    hasOddDetails: boolean;
    productBackstopId: number;
    showTooltip: boolean;
    oddIqEnabled: boolean;
    summary?: IInformSummary;
}

export class RatingStatus extends React.Component<IOverallRatingProps> {
    public render() {
        const {currentRating, previousRating, isSmallText} = this.props;
        const currentRatingTextClass = getRatingTextClass(currentRating || "",);

        return (
            <div className="brackets__box brackets__box__with-divider first odd-document-body"
                 data-testid="rating-status">
                <div className="rating__header-row">
                    <div className={isSmallText ? "" : `rating-status__container`}>
                        <div className="rating-status__title">
                            <h2><FormattedMessage id="product.aon-rating" defaultMessage="Aon Rating" /></h2>
                        </div>
                        <div className="rating-status__text">
                            {this.ratingPrefix()}
                            <div>
                                <span className={currentRatingTextClass} data-testid="current-rating">
                                    {this.getRatingText(this.props.currentRating)}
                                </span>
                                    {this.oddRatingDescriptionTooltip()}
                            </div>
                            <div className="rating__spacer"/>
                            {this.oddDetailsButton(this.props.productBackstopId)}
                            {this.props.summary && <Disclosures summary={this.props.summary}/>}
                        </div>
                    </div>
                </div>
            </div>);
    }

    private getRatingText(currentRating: string | null) {
        if (!currentRating) {
            return null;
        }

        const rating = this.props.currentRating === NR_RATING
            ? "N/R"
            : this.props.currentRating;

        return <FormattedMessage
            id={`research-product-rating.${rating}`}
            defaultMessage={rating!}
        />;
    }

    private ratingPrefix() {
        if (this.props.isOperationalDueDiligenceRating
            || this.props.ratingType !== ProductRatingType.INFORM
            || this.props.currentRating === NOT_RATED) {
            return null;
        }

        const grayRatingClass = getRatingTextClass(NR_RATING);
        return <span className={`rating-prefix ${grayRatingClass}`}>
             <FormattedMessage
                 id="research-product.inform-rating"
                 defaultMessage="InForm Rating"
             />:
        </span>;
    }

    private oddRatingDescriptionTooltip() {
        if (!this.props.isOperationalDueDiligenceRating || !this.props.showTooltip) {
            return null;
        }

        const tooltipProps: ITooltipProps = {
            iconClass: "fal fa-info-circle clickable rating__tooltip",
            hoverText: [OddRatingDescriptions(this.props.currentRating!)!],
            hoverTitle: this.props.currentRating
                        ? getTranslation(`research-product-rating.${this.props.currentRating}`, this.props.currentRating)
                        : "",
        };

        return <Tooltip {...tooltipProps}/>;
    }

    private oddDetailsButton(productBackstopId: number) {
        if (!this.props.hasOddDetails || !this.props.oddIqEnabled) {
            return null;
        }

        return <Link className="rating__odd-details-link" to={`/odd/${productBackstopId}`}>
            <RaisedButton
            className="rating__odd-details-button"
            style={viewOddDetailsButtonStyle}
            primary={true}>
                <FormattedMessage id="product.view-details" defaultMessage="View Details" />
            </RaisedButton>
        </Link>;
    }
}

// export default RatingStatus;